import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_3 = { class: "card-body p-4" }
const _hoisted_4 = { class: "alert alert-info d-flex align-items-start gap-2 mb-4" }
const _hoisted_5 = {
  key: 0,
  class: "mt-2 fw-semibold text-primary fs-13"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_8 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_9 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_10 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_11 = { class: "col-lg-12 col-md-12 mb-4 d-flex align-items-center" }
const _hoisted_12 = { class: "form-check form-switch" }
const _hoisted_13 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_14 = { class: "input-group" }
const _hoisted_15 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_16 = { class: "input-group" }
const _hoisted_17 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_18 = { class: "form-check form-switch mt-2" }
const _hoisted_19 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_20 = { class: "form-check form-switch mt-2" }
const _hoisted_21 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_22 = {
  key: 0,
  class: "col-lg-6 col-md-6 mb-4"
}
const _hoisted_23 = { class: "form-label text-dark fs-14 fw-medium" }
const _hoisted_24 = { class: "input-group" }
const _hoisted_25 = ["placeholder"]
const _hoisted_26 = { class: "input-group-text bg-light text-muted" }
const _hoisted_27 = { class: "col-lg-12 col-md-12 mb-4" }
const _hoisted_28 = { class: "d-flex justify-content-end gap-2 mt-2" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      pageTitle: _ctx.isEditing ? 'Edit Similarity Profile' : 'Add Similarity Profile',
      subTitle: "Management"
    }, null, 8, ["pageTitle"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[17] || (_cache[17] = _createElementVNode("i", { class: "material-symbols-outlined fs-20 text-info mt-1" }, "shield", -1)),
          _createElementVNode("div", null, [
            _cache[15] || (_cache[15] = _createElementVNode("strong", null, "Prinsip Keamanan Histori Order:", -1)),
            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "fs-13 text-secondary mt-1" }, " Perubahan pada profil ini hanya berlaku untuk pengecekan dan order berikutnya. Order terdahulu yang sudah terlanjur diproses tidak akan berubah status atau protokolnya. ", -1)),
            (_ctx.isEditing && _ctx.ordersCount > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _cache[14] || (_cache[14] = _createElementVNode("i", { class: "material-symbols-outlined fs-16 align-middle" }, "info", -1)),
                  _createTextVNode(" Profil ini sedang digunakan oleh " + _toDisplayString(_ctx.ordersCount) + " order historis. ", 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("form", {
          onSubmit: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[18] || (_cache[18] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, [
                _createTextVNode("Profile Code "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.profile_code) = $event)),
                placeholder: "e.g. JURNAL_STANDAR",
                onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleCodeInput && _ctx.handleCodeInput(...args))),
                required: ""
              }, null, 544), [
                [_vModelText, _ctx.form.profile_code]
              ]),
              _cache[19] || (_cache[19] = _createElementVNode("small", { class: "text-muted" }, "Kode unik profil (huruf kapital dan garis bawah).", -1))
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[20] || (_cache[20] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, [
                _createTextVNode("Profile Name "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.profile_name) = $event)),
                placeholder: "e.g. Jurnal Ilmiah Standar (Sinta 2-3)",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.form.profile_name]
              ]),
              _cache[21] || (_cache[21] = _createElementVNode("small", { class: "text-muted" }, "Nama tampilan profil benchmark.", -1))
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[23] || (_cache[23] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, [
                _createTextVNode("Klasifikasi Dokumen "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _withDirectives(_createElementVNode("select", {
                class: "form-select",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.service_classification) = $event)),
                required: ""
              }, _cache[22] || (_cache[22] = [
                _createStaticVNode("<option value=\"Artikel Jurnal\">Artikel Jurnal</option><option value=\"JAD Dosen\">JAD Dosen</option><option value=\"Skripsi/Tesis/Disertasi\">Skripsi/Tesis/Disertasi</option><option value=\"Proposal\">Proposal</option><option value=\"Laporan\">Laporan</option><option value=\"Lainnya\">Lainnya</option>", 6)
              ]), 512), [
                [_vModelSelect, _ctx.form.service_classification]
              ]),
              _cache[24] || (_cache[24] = _createElementVNode("small", { class: "text-muted" }, "Klasifikasi dokumen default yang ditautkan ke profil ini.", -1))
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[25] || (_cache[25] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Urutan Tampil (Sort Order)", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "form-control",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.sort_order) = $event)),
                placeholder: "0",
                min: "0"
              }, null, 512), [
                [_vModelText, _ctx.form.sort_order]
              ]),
              _cache[26] || (_cache[26] = _createElementVNode("small", { class: "text-muted" }, "Angka lebih kecil tampil lebih awal (default 0).", -1))
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: "isActive",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.is_active) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.form.is_active]
                ]),
                _cache[27] || (_cache[27] = _createElementVNode("label", {
                  class: "form-check-label text-dark fs-14 fw-medium",
                  for: "isActive"
                }, " Profil Aktif (dapat dipilih untuk order baru) ", -1))
              ])
            ]),
            _cache[41] || (_cache[41] = _createElementVNode("div", { class: "col-12 mb-3" }, [
              _createElementVNode("h6", { class: "fs-15 fw-semibold text-dark border-bottom pb-2 mb-3" }, [
                _createElementVNode("i", { class: "material-symbols-outlined fs-18 text-primary align-middle me-1" }, "speed"),
                _createTextVNode(" Batas Toleransi Similaritas (Thresholds) ")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_13, [
              _cache[29] || (_cache[29] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, [
                _createTextVNode("Max Toleransi Overall (%) "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createElementVNode("div", _hoisted_14, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  step: "0.01",
                  min: "0",
                  max: "100",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.default_max_overall) = $event)),
                  placeholder: "20",
                  required: ""
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.form.default_max_overall,
                    void 0,
                    { number: true }
                  ]
                ]),
                _cache[28] || (_cache[28] = _createElementVNode("span", { class: "input-group-text bg-light text-muted" }, "%", -1))
              ]),
              _cache[30] || (_cache[30] = _createElementVNode("small", { class: "text-muted" }, "Batas maksimal persentase total similarity keseluruhan index.", -1))
            ]),
            _createElementVNode("div", _hoisted_15, [
              _cache[32] || (_cache[32] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, [
                _createTextVNode("Max Toleransi Single Source (%) "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createElementVNode("div", _hoisted_16, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  step: "0.01",
                  min: "0",
                  max: "100",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.default_max_single_source) = $event)),
                  placeholder: "5",
                  required: ""
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.form.default_max_single_source,
                    void 0,
                    { number: true }
                  ]
                ]),
                _cache[31] || (_cache[31] = _createElementVNode("span", { class: "input-group-text bg-light text-muted" }, "%", -1))
              ]),
              _cache[33] || (_cache[33] = _createElementVNode("small", { class: "text-muted" }, "Batas toleransi maksimal dari satu sumber internet/publikasi tunggal.", -1))
            ]),
            _cache[42] || (_cache[42] = _createElementVNode("div", { class: "col-12 mb-3" }, [
              _createElementVNode("h6", { class: "fs-15 fw-semibold text-dark border-bottom pb-2 mb-3" }, [
                _createElementVNode("i", { class: "material-symbols-outlined fs-18 text-primary align-middle me-1" }, "tune"),
                _createTextVNode(" Pengaturan Filter Eksklusi Turnitin ")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: "excludeBiblio",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.exclude_bibliography) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.form.exclude_bibliography]
                ]),
                _cache[34] || (_cache[34] = _createElementVNode("label", {
                  class: "form-check-label text-dark fs-14 fw-medium",
                  for: "excludeBiblio"
                }, " Exclude Bibliography (Daftar Pustaka) ", -1))
              ]),
              _cache[35] || (_cache[35] = _createElementVNode("small", { class: "text-muted d-block mt-1" }, "Mengabaikan daftar pustaka / referensi saat pemeriksaan.", -1))
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: "excludeQuotes",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.exclude_quotes) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.form.exclude_quotes]
                ]),
                _cache[36] || (_cache[36] = _createElementVNode("label", {
                  class: "form-check-label text-dark fs-14 fw-medium",
                  for: "excludeQuotes"
                }, " Exclude Quotes (Tanda Kutip) ", -1))
              ]),
              _cache[37] || (_cache[37] = _createElementVNode("small", { class: "text-muted d-block mt-1" }, "Mengabaikan teks kutipan langsung dalam tanda petik.", -1))
            ]),
            _createElementVNode("div", _hoisted_21, [
              _cache[39] || (_cache[39] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Metode Filter Small Matches", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "form-select",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.small_matches_mode) = $event))
              }, _cache[38] || (_cache[38] = [
                _createElementVNode("option", { value: "none" }, "None (Tidak Memfilter Kecocokan Kecil)", -1),
                _createElementVNode("option", { value: "words" }, "Words (Berdasarkan Jumlah Kata)", -1),
                _createElementVNode("option", { value: "percentage" }, "Percentage (Berdasarkan Persentase)", -1)
              ]), 512), [
                [_vModelSelect, _ctx.form.small_matches_mode]
              ])
            ]),
            (_ctx.form.small_matches_mode !== 'none')
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("label", _hoisted_23, " Nilai Ambang Small Matches " + _toDisplayString(_ctx.form.small_matches_mode === 'words' ? '(Jumlah Kata)' : '(%)'), 1),
                  _createElementVNode("div", _hoisted_24, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      min: "1",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.small_matches_value) = $event)),
                      placeholder: _ctx.form.small_matches_mode === 'words' ? '10' : '1',
                      required: ""
                    }, null, 8, _hoisted_25), [
                      [
                        _vModelText,
                        _ctx.form.small_matches_value,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.form.small_matches_mode === 'words' ? 'kata' : '%'), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_27, [
              _cache[40] || (_cache[40] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Keterangan / Deskripsi Panduan", -1)),
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.description) = $event)),
                rows: "3",
                placeholder: "Catatan panduan pengecekan dokumen untuk tim verifikator/admin..."
              }, null, 512), [
                [_vModelText, _ctx.form.description]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_RouterLink, {
              to: "/similarity-profiles",
              class: "btn btn-secondary fs-15 fw-medium"
            }, {
              default: _withCtx(() => _cache[43] || (_cache[43] = [
                _createTextVNode("Batal")
              ])),
              _: 1
            }),
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-primary fs-15 fw-medium",
              disabled: _ctx.loading
            }, [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_30))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.isEditing ? 'Simpan Perubahan Profil' : 'Buat Profil Baru'), 1)
            ], 8, _hoisted_29)
          ])
        ], 32)
      ])
    ])
  ]))
}